import firebase from 'firebase/app';
import { makeJsDates } from '../utils/firebase';
import { updateLastActiveArrays } from './shared';

class Project {
  constructor(id, data) {
    this.id = id;
    Object.keys(data).forEach(key => {
      this[key] = data[key];
    });
  }

  toString() {
    return this.name + ', ' + this.id + ', ' + this.created;
  }
}

// Firestore data converter, see: https://firebase.google.com/docs/firestore/query-data/get-data#custom_objects
const projectConverter = {
  fromFirestore: (snapshot, options) => {
    let data = snapshot.data(options);
    data = makeJsDates(data);
    return new Project(snapshot.id, data);
  },
};

export function listenToUserProjects(
  onSnapshot,
  onError = e => console.error(e)
) {
  const db = firebase.firestore();
  return db
    .collection('projects')
    .where('members', 'array-contains', firebase.auth().currentUser.uid)
    .orderBy('created', 'asc')
    .withConverter(projectConverter)
    .onSnapshot(snapshot => {
      onSnapshot(snapshot.docs.map(doc => doc.data()));
    }, onError);
}

export async function addProject(projectName) {
  const db = firebase.firestore();
  const userID = firebase.auth().currentUser.uid;
  const timestamp = firebase.firestore.FieldValue.serverTimestamp();
  // Create the project first
  const projectRef = await db.collection('projects').add({
    name: projectName,
    admins: [userID],
    members: [userID],
    created: timestamp,
    modified: timestamp,
    lastUserActivity: {
      [userID]: timestamp,
    },
    createdBy: userID,
    isArchived: false,
  });
  // Update user's lastActiveProjects array
  await updateLastActiveArrays({ projectID: projectRef.id });
  return projectRef;
}

export async function updateProject(project, data) {
  const now = new Date();
  const db = firebase.firestore();
  const userID = firebase.auth().currentUser.uid;
  const projectRef = db.doc(`projects/${project.id}`);
  await projectRef.update({
    ...data,
    [`lastUserActivity.${userID}`]: now,
    modified: now,
    updatedBy: firebase.auth().currentUser.uid,
  });
  await updateLastActiveArrays({ projectID: project.id });
  return projectRef;
}

export function listenToProject(projectID, onSnapshot) {
  const db = firebase.firestore();
  const projectRef = db.doc(`projects/${projectID}`);
  return projectRef
    .withConverter(projectConverter)
    .onSnapshot(snapshot => onSnapshot(snapshot.data()));
}
